import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  colors: null,
  gameMode: null,
  gameType: null,
  gameName: null,
  totalUserPoints: 0,
  pointsPerMiniGame: 0,
  playersDetails: {},
  miniGameType: null,
  miniGames: [],
  miniGamesImagesForSwipe: [],
  currentMiniGameRound: 0,
  unauthorizedWinnerInfo: {
    msisdn: null,
    prizeId: null,
    name: null,
    existPrize: false,
    gameType: null,
    imageWonUrl: null,
    code: null,
  },
  isGamePage: null,
  shuffledCardDTOS: null,
  attemptsUsed: null,
  gameCardDTOS: [],
  gameStateEnumForResumeGame: null,
  transitionOnlyForSearchingToOpponent: false,
  gameInProgress: false,
  gameID: null,
  gameFinished: false,
  gameWinnerMSISDN: '',
  gameWinnerUsername: '',
  registrationPoints: {},
  answerInFlight: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




// WEBPACK FOOTER //
// ./src/store/modules/game/index.js